import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { Zap } from 'lucide-react';
import { trackAddToCart } from '../../utils/metaPixel';
export function FinalCTA() {
  return <section id="comprar" className="py-24 md:py-32 px-6 bg-[#7C8B6F] text-white" data-id="element-80">
      <div className="max-w-2xl mx-auto text-center space-y-12" data-id="element-81">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-6" data-id="element-82">
          <h2 className="text-3xl md:text-4xl font-serif leading-snug" data-id="element-83">
            Si estás cansado/a de repetir el ciclo…
          </h2>
          <p className="text-lg md:text-xl text-[#E5E0D8] leading-relaxed" data-id="element-84">
            si quieres dejar de negociar con el impulso… y necesitas una guía
            práctica para empezar hoy:
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="relative" data-id="element-85">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 z-10" data-id="element-86">
            <button onClick={() => {
            const el = document.getElementById('cta-comprar');
            if (el) el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            });
          }} className="inline-flex items-center gap-1.5 bg-[#D4915D] text-white text-sm font-bold px-4 py-1.5 rounded-full shadow-lg cursor-pointer hover:bg-[#C4804C] transition-colors" data-id="element-87">
              <Zap className="w-4 h-4" data-id="element-88" />
              OFERTA POR TIEMPO LIMITADO
            </button>
          </div>
          <div className="bg-white/15 backdrop-blur-sm border-2 border-[#D4915D]/60 rounded-2xl p-6 md:p-8" data-id="element-89">
            <p className="text-lg text-[#E5E0D8] mb-3" data-id="element-90">
              Precio regular:{' '}
              <span className="line-through text-[#E5E0D8]/60" data-id="element-91">$15.99</span>
            </p>
            <div className="flex items-center justify-center gap-4" data-id="element-92">
              <span className="text-5xl md:text-6xl font-bold text-white" data-id="element-93">
                $6.39
              </span>
              <span className="bg-[#D4915D] text-white text-lg font-bold px-3 py-1 rounded-lg -rotate-2" data-id="element-94">
                -60%
              </span>
            </div>
            <p className="text-sm text-[#E5E0D8]/70 mt-3" data-id="element-95">
              Ahorras $9.60 — Descuento aplicado automáticamente
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} data-id="element-96">
          <div className="bg-white/10 p-8 md:p-10 rounded-2xl backdrop-blur-sm border border-white/20 space-y-8" data-id="element-97">
            <h3 className="text-xl md:text-2xl font-serif leading-snug" data-id="element-98">
              Descarga "Cómo manejar la ansiedad durante la abstinencia"
            </h3>

            <div className="max-w-sm mx-auto" data-id="element-99">
              <img src="https://cdn.magicpatterns.com/uploads/1AMDmsn2Dv6JaYdPJH8WUD/heylloyd-image-1770241548684.png" alt="Ebook disponible en tablet y móvil - Cómo manejar la ansiedad durante la abstinencia" className="w-full rounded-lg shadow-xl" data-id="element-100" />
            </div>

            <div id="cta-comprar" className="flex flex-col items-center gap-2" data-id="element-101">
              <motion.button whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} onClick={() => {
              trackAddToCart();
              window.location.href = 'https://mjebook.com/cart/43035665268854:1';
            }} className="inline-flex items-center justify-center gap-2 rounded-lg font-semibold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-[#FAF8F5] cursor-pointer bg-[#D4915D] text-white hover:bg-[#C4804C] shadow-md hover:shadow-lg focus:ring-[#D4915D]/50 active:bg-[#B5703D] h-14 w-full max-w-sm mx-auto text-lg font-bold shadow-xl" data-id="element-102">
                QUIERO EMPEZAR AHORA
              </motion.button>
              <span className="text-2xl font-bold text-white" data-id="element-103"></span>
            </div>
            <p className="text-base text-[#E5E0D8]/80" data-id="element-104">
              Comienza el Día 1 ahora mismo
            </p>
          </div>
        </motion.div>

        <div className="pt-12 border-t border-white/20" data-id="element-105">
          <p className="font-serif text-lg mb-3" data-id="element-106">P.D.</p>
          <p className="text-[#E5E0D8] text-lg leading-relaxed" data-id="element-107">
            Muchas recaídas no ocurren porque la persona "no quería cambiar".
            Ocurren porque en el pico de ansiedad no tenía un plan. Este ebook
            está hecho para que, cuando llegue la ola, tú tengas qué hacer: paso
            a paso.
          </p>
        </div>
      </div>
    </section>;
}